import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AolService {
  baseUrl: string = environment.API_SERVER;
  payment: any;
  constructor(private _http: HttpClient) {}

  getFinancialEnd(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/aol/get-year-end/?organizationId=${payload.organizationId}`,
      payload.body
    );
  }
  updateShareDetails(payload) {
    return this._http.put(
      `${this.baseUrl}/enterprise_org/${payload.nccId}/share_details`,
      payload.body
    );
  }
  getDocument(payload) {
    return this._http.get(`${this.baseUrl}/document/${payload.documentId}/`);
  }
  getAllDocumentTypes(payload) {
    return this._http.get(
      `${this.baseUrl}/contractors/${payload.organizationId}/documents/`,
      {
        params: payload.params,
      }
    );
  }
  getAllSupportingDocumentTypes(payload) {
    return this._http.get(`${this.baseUrl}/supporting-documents`, {
      params: payload.params,
    });
  }

  getDocumentUpload(payload) {
    return this._http.get(
      `${this.baseUrl}/object-document/${payload.optionId}`
    );
  }
  getTinFromFirs(payload) {
    return this._http.get(
      `${this.baseUrl}/record/${payload.organizationId}/get-tin`
    );
  }
  createFinancialEnd(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-update-year-end/`,
      payload.body
    );
  }
  createOrganizationAOl(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add/`,
      payload.body
    );
  }
  createAOL(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add/`,
      payload.body
    );
  }
  submitCompanyDetails(payload) {
    return this._http.patch(
      `${this.baseUrl}/supporting-documents/document/name?supportingDocumentId=${payload.supportingdocumentId}&documentName=${payload.documentName}`,
      payload.body
    );
  }
  submitAOLDetails(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/aol/${payload.organizationAolId}/submit/`
    );
  }
  createNetworkAssessment(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-finance-network-operator/`,
      payload.body
    );
  }
  createContractorNetworkAssessment(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-network-operator/?organizationAolId=${payload.organizationAolId}`,
      payload.body
    );
  }
  createContractorNonNetworkAssessment(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-non-network-operator/?organizationAolId=${payload.organizationAolId}`,
      payload.body
    );
  }
  editContractorNetworkAssessment(payload) {
    return this._http.put(
      `${this.baseUrl}/organizations/aol/update-network-operator/?networkOperatorAssessmentId=${payload.networkOperatorAssessmentId}`,
      payload.body
    );
  }
  editContractorNonNetworkAssessment(payload) {
    return this._http.put(
      `${this.baseUrl}/organizations/aol/update-non-network-operator/?nonNetworkOperatorAssessmentId=${payload.nonNetworkOperatorAssessmentId}`,
      payload.body
    );
  }
  deleteContractorNetworkAssessment(payload) {
    return this._http.delete(
      `${this.baseUrl}/organizations/aol/delete-network-operator/?networkOperatorAssessmentId=${payload.networkOperatorAssessmentId}`
    );
  }
  deleteContractorNonNetworkAssessment(payload) {
    return this._http.delete(
      `${this.baseUrl}/organizations/aol/delete-non-network-operator/?nonNetworkOperatorAssessmentId=${payload.nonNetworkOperatorAssessmentId}`
    );
  }
  editNetworkAssessment(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-details/`,
      payload.body
    );
  }
  uploadAOLDocuments(payload) {
    return this._http.post(
      `${this.baseUrl}/organizations/aol/add-document/
`,
      payload.body
    );
  }

  getOrganizationAol(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/aol/${payload.organizationId}/details/`,
      {
        params: payload.params,
      }
    );
  }
  getOrganizationAolDetails(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/aol/${payload.organizationAolId}/aol-details/`,
      {
        params: payload.params,
      }
    );
  }
  getOrganizationAolSummary(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/aol/${payload.organizationId}/summary/`,
      {
        params: payload.params,
      }
    );
  }
  getDocuments(payload) {
    return this._http.get(
      `${this.baseUrl}/organizations/aol/documents/?organizationAolId=${payload.organizationAolId}`
    );
  }
  deleteDocuments(payload) {
    return this._http.delete(
      `${this.baseUrl}/organizations/aol/delete-document/?aolDocumentId=${payload.aolDocumentId}`
    );
  }
  updateDocument(payload) {
    return this._http.put(
      `${this.baseUrl}/organizations/aol/update-document/?aolDocumentId=${payload.aolDocumentId}`,
      payload.body
    );
  }
  getAllfinancialEnd(payload) {
    return this._http.get(
      this.baseUrl +
        `/organizations/aol/get-year-end/?organizationId=${payload.organizationId}`,
      payload.body
    );
  }
}
